<template>
  <div class="container" v-if="isLoggedIn">
    <!-- 서브상단영역 -->

    <Banner
      title="전문가교육"
      subtitle="전문가교육"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />

    <!-- //서브상단영역 -->

    <BoardNavbar />

    <div class="width_wrap">
      <div class="body_content">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">전문가 과정</h1>
        <!-- //서브 타이틀영역 -->

        <div class="menu-A-read-wrap">
          <div>
            <ul class="line line4">
              <li>성장 – 폴리오 전문가 과정</li>
              <li>
                <dl class="line2">
                  <dt>제목</dt>
                  <dd>성장 – 폴리오_전문가 과정</dd>
                </dl>
              </li>
            </ul>
          </div>
          <div>
            <ul>
              <li>
                <figure>
                  <n-space justify="center">
                    <img
                      src="@/assets/thum_img/kp708b/sub5_1/31c88223833075ed30512f582928a4a7_water__c1_w280_h397.jpg"
                      alt=""
                    />
                  </n-space>
                </figure>
              </li>
              <li>
                <dl>
                  <dt>목적</dt>
                  <dd>
                    "성장–폴리오_전문가 과정"은 교사를 비롯한 상담전문가 등을
                    대상으로, 중고등학생 및 대학생의 진로 선택, 진학, 취업 등을
                    안내, 코칭할 수 있는 전문성 함양을 목적으로 한다.
                  </dd>
                </dl>

                <dl>
                  <dt>목표</dt>
                  <dd>
                    목표 1. 참여자는 21세기 핵심 역량인 창의역량, 재능, 경험
                    등에 관한 학문적 배경을 탐색한다. <br />
                    목표 2. 중고등학생 및 대학생의 진로, 선발 및 진학, 전공 및
                    직업군, 취업 등과 관련된 평가 방법을 탐색한다. <br />
                    목표 3. 참여자는 핵심 역량 기반의 '성장모델'의 개념모델을
                    탐색한다.<br />
                    목표 4. '교육_성장-폴리오' 과정의 내용 구성 및 운영에 관하여
                    이해하고, 이를 기반으로 'MY 성장모델'을 시뮬레이션 한다.
                    <br />
                    목표 5. 모든 참가자가 'MY 성장시스템'을 발표한다. 이때 또래
                    평가를 진행한다.<br />
                  </dd>
                </dl>

                <dl>
                  <dt>대상</dt>
                  <dd>교과 교사, 진로 교사, 상담 교사, 상담 전문가 등<br /></dd>
                </dl>

                <dl class="line2">
                  <dt>구분·시수</dt>
                  <dd>15시간</dd>
                </dl>
              </li>
            </ul>
          </div>

          <div>
            <ul class="line line4">
              <li>
                결과물<br />
                • '교육_성장-폴리오' 과정 운영 계획서<br />
                • 'MY 성장모델'
              </li>
              <li>
                <dl class="line2">
                  <dt>구성</dt>
                  <dd>
                    • 모듈 1. (1) 개회식 및 프로그램 소개, (2) 21세기 핵심
                    역량에 대한 학문적 배경의 탐색 <br />
                    • 모듈 2. 진로, 선발 및 진학, 전공 및 직업군, 취업 등과
                    관련된 평가 방법의 탐색
                    <br />
                    • 모듈 3. 역량모델링 및 '성장모델'의 개념모델의 탐색<br />
                    • 모듈 4. (1)'교육_성장-폴리오' 과정의 내용 구성 및 운영에
                    대한 이해, (2)'MY 성장모델'의 시뮬레이션<br />
                    • 모듈 5. 'MY 성장시스템'의 발표 및 평가
                  </dd>
                </dl>
              </li>
            </ul>
          </div>

          <div>
            <ul class="line box22">
              <li>
                강의<br />
                강의 진행자 <br />
                <br />
                • 선발 및 진학 전문가<br />
                • '성장–폴리오 전문가 과정' 수료자
              </li>
              <li>
                <dl class="line2">
                  <dt>이수혜택</dt>
                  <dd>
                    • 'Activity_성장-폴리오_학생 과정' 운영 자격 부여<br />
                    • '교육_성장-폴리오_전문가 과정' 강의 자격 부여
                  </dd>
                </dl>
              </li>
            </ul>
          </div>

          <div class="btn">
            <router-link :to="`${USER_ROUTES.Product.Expert.Expert.Path}`"
              >목록</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BoardNavbar from "@/views/product/expert/Navbar.vue";
import Banner from "@/components/Banner.vue";

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";
const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.menu-A-read-wrap * {
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  word-break: keep-all;
  box-sizing: border-box;
}
.menu-A-read-wrap > div h1 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 30px;
  text-align: center;
}
.menu-A-read-wrap > div ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.menu-A-read-wrap > div ul.box22 {
  padding: 20px 0;
}
.menu-A-read-wrap > div ul li {
  width: 100%;
  font-size: 14px;
  line-height: 1.7em;
}

.menu-A-read-wrap > div ul li:nth-child(1) {
  padding: 20px 0;
  border-bottom: 1px solid #ddd;
}
.menu-A-read-wrap > div ul li dl {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 22px 0;
  border-bottom: 1px solid #ddd;
}

.menu-A-read-wrap > div ul li dl dt {
  width: 100%;
  margin-bottom: 10px;
}
.menu-A-read-wrap > div ul li dl dd {
  line-height: 1.7em;
  width: 100%;
}

.menu-A-read-wrap div.btn {
  margin-top: 50px;
  text-align: center;
}
.menu-A-read-wrap div.btn a {
  display: inline-block;
  text-align: center;
  font-size: 15px;
  background: #fff;
  color: #004e31;
  padding: 5px 25px;
  transition: all 0.2s;
  border: 1px solid #004e31;
  font-weight: 500;
}

@media (min-width: 768px) {
  .menu-A-read-wrap > div ul li dl {
    align-items: center;
  }
  .menu-A-read-wrap > div ul li dl.line3 {
    border-top: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul.line {
    border-bottom: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul li dl.line2 {
    border-bottom: none;
  }
  .menu-A-read-wrap > div ul.line4 {
    border-top: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul li:nth-child(1) {
    width: 180px;
    padding: 0;
    text-align: center;
    border-bottom: none;
  }
  .menu-A-read-wrap > div ul li:nth-child(2) {
    width: calc(100% - 200px);
  }
  .menu-A-read-wrap > div ul li {
    font-size: 15px;
  }
  .menu-A-read-wrap > div ul li dl dt {
    width: 80px;
    margin-bottom: 0;
  }
  .menu-A-read-wrap > div ul li dl dd {
    line-height: 1.7em;
    width: calc(100% - 90px);
  }
}

@media screen and (min-width: 1100px) {
  .menu-A-read-wrap > div ul li:nth-child(1) {
    width: 270px;
    padding: 0;
  }
  .menu-A-read-wrap > div ul li:nth-child(2) {
    width: calc(100% - 320px);
  }
}
</style>
